import React from 'react';
import { Box, Flex, TextV2 } from '@withjoy/joykit';
import { WebGlobe, Phone } from '@withjoy/joykit/icons';
import { AccommodationCard, TravelMapBlockType } from '../../Accommodations.types';
import { pxToRem } from '@withjoy/joykit/theme';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';

export const HotelTags = ({ hotel }: { hotel: AccommodationCard }) => {
  const getHotelTags = useEventCallback((hotel: AccommodationCard) => {
    const tags = [];

    if (hotel?.websiteUrl && hotel.type === TravelMapBlockType.travelMapAccommodationsCustom) {
      tags.push({ label: hotel?.websiteUrl, icon: <WebGlobe /> });
    }

    if (hotel?.customPhone && hotel.type === TravelMapBlockType.travelMapAccommodationsCustom) {
      tags.push({ label: hotel?.customPhone, icon: <Phone /> });
    }

    return tags;
  });

  const tags = getHotelTags(hotel);

  if (!tags.length) return null;

  return (
    <Flex
      gap={3}
      flexWrap="wrap"
    >
      {tags.map(tag => (
        <Tag
          key={tag.label}
          tag={tag}
        />
      ))}
    </Flex>
  );
};

const Tag = ({ tag }: { tag: { label: string; icon: React.ReactNode } }) => {
  return (
    <Flex
      alignItems="center"
      gap={3}
      width="fit-content"
      paddingX={5}
      paddingY={3}
      borderRadius={3}
      border="1px solid"
      borderColor="mono3"
    >
      <Box>{tag.icon}</Box>
      <TextV2
        typographyVariant="body1"
        maxWidth={{ _: pxToRem(180), sm: pxToRem(260) }}
        truncate
      >
        {tag.label}
      </TextV2>
    </Flex>
  );
};
